export enum TextTypeEnum {
  Bid = 'Bid'
}
